import { NgModule } from '@angular/core';
import { ObjectFieldsComponent } from './object-fields/object-fields.component';
import { ObjectFieldTemplatesComponent } from './object-field-templates/object-field-templates.component';
import { SettingsComponent } from './settings/settings.component';
import { SharedModule } from '../shared/shared/shared.module';
import { EditObjectFieldComponent } from './object-fields/edit-object-field/edit-object-field.component';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    ObjectFieldsComponent,
    ObjectFieldTemplatesComponent,
    SettingsComponent,
    EditObjectFieldComponent
  ],
  entryComponents: [
    EditObjectFieldComponent
  ]
})
export class SettingsModule {
}



// WEBPACK FOOTER //
// ./src/app/settings/settings.module.ts